<template>
  <div>
    <b-form-file v-model="uploadfile"
                 @input="upload"
                 placeholder="Drop file here"></b-form-file>
    <b-alert :show="alertShow" variant="success" dismissible>
      <p style="padding-right: 32px">We're loading your file for suppression. When it is ready, typically within 30 minutes, you will be alerted via email.
        You will then see this file in the 'Suppress Uploaded File' option when building your list.
     </p>
    </b-alert>

    <b-modal id="upladSuppression"
             size="lg"
             title="Upload a File for Suppression"
             @ok = "save">
      Your file has uploaded successfully.Total count record is {{items.length}}
      <div class="table-box">
        <table class="table">
          <tr>
            <td v-for = "col in uploadlistcolumns">{{col.ColumnName}}</td>
          </tr>
          <tr v-for ="row in items" >
            <td v-for = "col in row.RowData">{{col.Data}}</td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>

</template>

<script>
  export default {
    components: {
    },
    props: {
    },
    created () {
    },
    data () {
      return {
        uploadfile: null,
        items: [],
        uploadlistcolumns: [],
        targetFile: '',
        alertShow: false
      }
    },
    computed: {
      listType () {
        return this.$store.state.order.ListType
      }
    },
    watch: {
    },
    methods: {
      upload () {
        this.alertShow = false
        let formData = new FormData()
        formData.append('filename', this.uploadfile, this.uploadfile.filename)
        this.$http.post('Common/ExcelUploader.ashx', formData)
          .then(resp => {
            this.targetFile = resp.body.DataSource
            this.targetFile.UserFileName = this.uploadfile.filename
            this.getRecord(resp.body.DataSource.TargetFile)
          })
      },
      getRecord (TargetFile) {
        this.$http.post('PlaceOrder.aspx/GetRecord', {
          filePath: TargetFile,
          type: 1
        }).then(resp => {
          this.items = resp.body.d.DataSource.SuccessRow
          this.uploadlistcolumns = resp.body.d.DataSource.UpLoadListColumn
          this.$root.$emit('bv::show::modal', 'upladSuppression')
        })
      },
      save () {
        this.$http.post('PlaceOrder.aspx/ProcessCustomSuppressionFile', {
          file: this.targetFile,
          listType: this.listType
        }).then(resp => {
          this.uploadNotifier()
        })
      },
      uploadNotifier () {
        this.$http.post('PlaceOrder.aspx/SuppressionUploadNotifier', {
          Quantity: this.items.length
        }).then(resp => {
          this.alertShow = true
        })
      }
    }
  }
</script>

<style scoped lang="scss">

  .tr{
    padding: 0;
  }
  .td{
    padding: 0;
  }
  .table{
    font-size: 12px;
    max-height: 400px;
    overflow: scroll;
  }
  .table-box{
    max-height: 400px;
    overflow: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/MUploadsuppression.vue